module.exports = __webpack_public_path__ + "img/0010.fe2bac0d.jpg";